
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolio-guide",
      function () {
        return require("private-next-pages/portfolio-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portfolio-guide"])
      });
    }
  